import { Reveal, SectionHeading } from "@/components/Reveal";
import { GALLERY } from "@/data/site";

const SPANS = ["md:col-span-7 md:row-span-2", "md:col-span-5", "md:col-span-5", "md:col-span-12"];

export function Gallery() {
  return (
    <section id="galleria" className="py-24 sm:py-32 bg-[#0D0E13] border-y border-white/5" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHeading
          eyebrow="Droni in Azione"
          title={
            <>
              La tecnologia <span className="fire-text">al lavoro</span>
            </>
          }
          sub="Ogni intervento è documentato: prima, durante e dopo. Guarda come i nostri droni riportano i pannelli al massimo splendore."
        />

        <div className="grid md:grid-cols-12 gap-5 mt-16 md:auto-rows-[240px]">
          {GALLERY.map((g, i) => (
            <Reveal key={g.title} delay={i * 0.08} className={SPANS[i]}>
              <figure
                className="group relative rounded-3xl overflow-hidden border border-white/10 h-64 md:h-full"
                data-testid={`gallery-item-${i}`}
              >
                <img
                  src={g.image}
                  alt={g.title}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-[1.2s] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#050507]/85 via-transparent to-transparent" />
                <figcaption className="absolute bottom-0 left-0 right-0 p-6 flex items-end justify-between gap-3">
                  <div>
                    <span className="font-mono-adj text-[9px] uppercase tracking-[0.25em] text-orange-400 border border-orange-500/30 rounded-full px-3 py-1">
                      {g.tag}
                    </span>
                    <p className="font-heading font-bold text-white text-lg mt-3">{g.title}</p>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
